<script>
import appConfig from '@src/app.config'
import dayjs from 'dayjs'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Certificate',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {  },
  data() {
    return {
      title: 'Certificate',
      tasks: [
        {
          id: 1,
          certificate: 'Keselamatan Konstruksi',
          place: 'Jakarta',
          start: this.getDate(-24 * 5),
          duration: 15 * 24 * 60 * 60 * 1000,
          status: 'Active'
          // collapsed: true,
        },
        /* {
          id: 2,
          label: 'With great power comes great responsibility',
          user:
              '<a href="https://www.google.com/search?q=Peter+Parker" target="_blank" style="color:#0077c0;">Peter Parker</a>',
          parentId: 1,
          start: this.getDate(-24 * 4),
          duration: 4 * 24 * 60 * 60 * 1000,
          type: 'milestone',
          collapsed: true,
          style: {
            base: {
              fill: '#1EBC61',
              stroke: '#0EAC51'
            }
            /* 'tree-row-bar': {
              fill: '#1EBC61',
              stroke: '#0EAC51'
            },
            'tree-row-bar-polygon': {
              stroke: '#0EAC51'
            }
          }
        }, */
        {
          id: 2,
          certificate: 'P 3 K',
          place:
              'Jakarta',
          start: this.getDate(-24 * 3),
          duration: 2 * 24 * 60 * 60 * 1000,
          status: '30 Hari Akan Expired'
        },
        {
          id: 3,
          certificate: 'Radio',
          place:
              'Jakarta',
          start: this.getDate(-24 * 2),
          duration: 2 * 24 * 60 * 60 * 1000,
          status: 'Expired',
          dependentOn: [3]
        }
      ],
      options: {
        maxRows: 100,
        maxHeight: 300,
        title: {
          label: 'Doc. Class & Statutory',
          html: false
        },
        row: {
          height: 24
        },
        calendar: {
          hour: {
            display: false
          }
        },
        chart: {
          progress: {
            bar: false
          },
          expander: {
            display: true
          }
        },
        taskList: {
          expander: {
            straight: false
          },
          columns: [
            {
              id: 1,
              label: 'No',
              value: 'id',
              width: 40
            },
            {
              id: 2,
              label: 'Class & Statutory',
              value: 'certificate',
              width: 200,
              expander: true,
              html: true,
              /* events: {
                click({ data, column }) {
                  alert('description clicked!\n' + data.label);
                }
              } */
            },
            {
              id: 3,
              label: 'Place Issued',
              value: 'place',
              width: 130,
              html: true
            },
            {
              id: 3,
              label: 'Date Issued',
              value: task => dayjs(task.start).format('YYYY-MM-DD'),
              width: 78
            },
            {
              id: 4,
              label: 'Status Certificate',
              value: 'status',
              width: 68,
              /* style: {
                'task-list-header-label': {
                  'text-align': 'center',
                  width: '100%'
                },
                'task-list-item-value-container': {
                  'text-align': 'center',
                  width: '100%'
                }
              } */
            }
          ]
        }
        // locale:{
        //   name: 'ja', // name String
        //   weekdays: 'Poniedziałek_Wtorek_Środa_Czwartek_Piątek_Sobota_Niedziela'.split('_'), // weekdays Array
        //   weekdaysShort: 'Pon_Wto_Śro_Czw_Pią_Sob_Nie'.split('_'), // OPTIONAL, short weekdays Array, use first three letters if not provided
        //   weekdaysMin: 'Pn_Wt_Śr_Cz_Pt_So_Ni'.split('_'), // OPTIONAL, min weekdays Array, use first two letters if not provided
        //   months: 'Styczeń_Luty_Marzec_Kwiecień_Maj_Czerwiec_Lipiec_Sierpień_Wrzesień_Październik_Listopad_Grudzień'.split('_'), // months Array
        //   monthsShort: 'Sty_Lut_Mar_Kwi_Maj_Cze_Lip_Sie_Wrz_Paź_Lis_Gru'.split('_'), // OPTIONAL, short months Array, use first three letters if not provided
        //   ordinal: n => `${n}`, // ordinal Function (number) => return number + output
        //   relativeTime: { // relative time format strings, keep %s %d as the same
        //     future: 'za %s', // e.g. in 2 hours, %s been replaced with 2hours
        //     past: '%s temu',
        //     s: 'kilka sekund',
        //     m: 'minutę',
        //     mm: '%d minut',
        //     h: 'godzinę',
        //     hh: '%d godzin', // e.g. 2 hours, %d been replaced with 2
        //     d: 'dzień',
        //     dd: '%d dni',
        //     M: 'miesiąc',
        //     MM: '%d miesięcy',
        //     y: 'rok',
        //     yy: '%d lat'
        //   }
        // }
      },
      hasSub: false,
      notOnBoard: false,
      expired: false,
      showAddCategory: false,
      officeChecked: false,
      shipChecked: false,
      selectedStatusCertificate: 1,
      selectedTypeCertificate: 1,
      perpanjang: '',
      vehicle: [
        {
          label: 'Tug Boat',
          checked: true,
          disabled: false
        },
        {
          label: 'Barge',
          checked: false,
          disabled: false
        },
        {
          label: 'Heavy Equipment',
          checked: false,
          disabled: false
        }
      ],
      remarks: [
        {
          label: 'Full Term',
          color: 'success',
          value: 'full_term'
        },
        {
          label: 'Short Term',
          color: 'warning',
          value: 'short_term'
        },
        {
          label: 'Provisional',
          color: 'danger',
          value: 'provisional'
        },
        {
          label: 'Permanent',
          color: 'primary',
          value: 'permanent'
        }
      ],
      statusCertificate: [
        { value: '1', text: 'All' },
        { value: '22', text: 'Active' },
        { value: '2', text: '30 Day Will Expired' },
        { value: '3', text: 'Expired' },
        { value: '4', text: 'Expired This Year' },
        { value: '5', text: 'Expired Next Year' }
      ],
      typeCertificate: [
        { value: '1', text: 'All' },
        { value: '2', text: 'Permanent' },
        { value: '3', text: 'Long Term' },
        { value: '4', text: 'Short Term' },
        { value: '5', text: 'Provisional' },
      ],
      reminder: [
        {
          label: '6 Bulan Sebelumnya',
          checked: true,
          disabled: false
        },
        {
          label: '3 Bulan Sebelumnya',
          checked: true,
          disabled: false
        },
        {
          label: '2 Bulan Sebelumnya',
          checked: false,
          disabled: false
        },
        {
          label: '1 Bulan Sebelumnya',
          checked: false,
          disabled: false
        },
        {
          label: '3 Minggu Sebelumnya',
          checked: false,
          disabled: false
        },
        {
          label: '2 Minggu Sebelumnya',
          checked: false,
          disabled: false
        },
        {
          label: '1 Minggu Sebelumnya',
          checked: false,
          disabled: false
        },
        {
          label: '6 Hari Sebelumnya',
          checked: false,
          disabled: false
        },
        {
          label: '5 Hari Sebelumnya',
          checked: false,
          disabled: false
        },
        {
          label: '4 Hari Sebelumnya',
          checked: false,
          disabled: false
        },
        {
          label: '3 Hari Sebelumnya',
          checked: false,
          disabled: false
        },
        {
          label: '2 Hari Sebelumnya',
          checked: false,
          disabled: false
        },
        {
          label: '1 Hari Sebelumnya',
          checked: false,
          disabled: false
        },
        {
          label: 'Hari H Expired',
          checked: false,
          disabled: false
        }
      ],
      certificate: [
        { fleet: 'TB.ETI 301', value: 1, name: 'Keselamatan Konstruksi', place_issued: 'Samarinda', image: require('@assets/images/flaticon/certificate.png'), date_issued: '10 November 2010', expired: '18 Oktober 2024', endorsement: '', remark: 'Permanent', status: 'Active' },
        // eslint-disable-next-line standard/object-curly-even-spacing
        { fleet: 'BG.TCP 3301', value: 2, name: 'P3K', place_issued: 'Samarinda', image: require('@assets/images/flaticon/certificate.png'), date_issued: '10 November 2010', expired: '18 Oktober 2024', endorsement: '6 Agustus 2021', remark: 'Full Term', status: '30 Hari Lagi Expired' },
        { fleet: 'TB.TCP 103', value: 3, name: 'Radio', place_issued: 'Jakarta', image: require('@assets/images/flaticon/certificate.png'), date_issued: '10 November 2010', expired: '18 Oktober 2024', endorsement: '', remark: 'Short Term', status: 'Expired' }
      ],
      fleet: [
        { value: '1', text: 'TB.TCP-202' },
        { value: '2', text: 'BG.SML-105' },
        { value: '3', text: 'BG.ETI-201' }
      ],
      category: [
        { value: '1', text: 'Class' },
        { value: '2', text: 'Non Class' }
      ],
      certificateName: [
        { value: '1', text: 'SNPP' },
        { value: '2', text: 'Surat Laut' },
        { value: '3', text: 'Keselamatan Radio' }
      ]
    }
  },
  mounted() {

  },
  methods: {
    getDate(hours) {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth() + 1;
      const currentDay = currentDate.getDate();
      const timeStamp = new Date(`${currentYear}-${currentMonth}-${currentDay} 00:00:00`).getTime();
      return new Date(timeStamp + hours * 60 * 60 * 1000).getTime();
    },
    deleteCertificate (index) {
      this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal.fire(
              'Deleted!',
              'Your data has been deleted.',
              'success'
          )
        }
      })
    },
    showAddCategoryAction () {
      this.showAddCategory = true
    },
    hideAddCategory () {
      this.showAddCategory = false
    }
  }
}
</script>

<template>
  <div>
    <b-tabs pills justified class="navtab-bg">
      <b-tab title="Certificate List" active>
        <b-row>
          <b-col lg="12">
            <b-card class="iq-mb-3">
              <b-card-title>
                <b-row>
                  <b-col lg="6">
                    <h5 class="card-title font-size-16 mt-2">Certificate - AWB OCB Tanjung Lesung</h5>
                  </b-col>
                  <b-col lg="6" class="text-right">
                    <router-link to="/ops/export-certificate"><b-button v-b-modal.add-row variant="dark" class="mr-1"><i class="fa fa-file-excel"></i>Export</b-button></router-link>
                    <b-button v-b-modal.add-certificate variant="success" class="mr-1"><i class="fa fa-plus"></i>Add Certificate</b-button>
                    <b-modal id="add-certificate" size="lg" title="Add Certificate" ok-title="Submit" cancel-title="Close" :no-close-on-backdrop="true">
                      <fieldset class="form-group border p-3">
                        <legend class="w-auto px-2">Details:</legend>
                        <b-row>
                          <b-col md="6">
                            <b-form-group label="Certificate/Serial Number:" label-for="serial">
                              <b-form-input id="serial" type="text" placeholder="Certificate / Serial Number"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label="Folder Number / Code:" label-for="serial">
                              <b-form-input id="serial" type="text" placeholder="Folder No / Code"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label="Name of Certificate:" label-for="category">
                              <v-select label="text" :options="certificateName"></v-select>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label="Category" label-for="category">
                              <h5>-</h5>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label="Fleet:" label-for="fleet">
                              <v-select label="text" :options="fleet"></v-select>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label-for="certificateFile" label="File Certificate">
                              <b-form-file
                                  id="customFile"
                                  placeholder="Choose a file"
                              ></b-form-file>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label-for="placeIssued" label="Place Issued">
                              <b-form-input id="place_issued" type="text" placeholder="Place Issued"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label-for="location" label="Location">
                              <b-form-input id="place_issued" type="text" placeholder="Location"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label="Not on Board" label-for="notOnBoard">
                              <b-form-checkbox v-model="notOnBoard" name="check-button" switch inline>
                                Yes / No
                              </b-form-checkbox>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </fieldset>
                      <fieldset class="form-group border p-3">
                        <legend class="w-auto px-2">Validity:</legend>
                        <b-row>
                          <b-col md="6">
                            <b-form-group label-for="dateIssued" label="Date Issued">
                              <b-form-input type="date" value="2019-12-19"></b-form-input>
                              <small style="float: right">click <i class="fa fa-calendar"></i> to show</small>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label-for="expired" label="Valid Until">
                              <b-form-input type="date" value="2019-12-19"></b-form-input>
                              <small style="float: right">click <i class="fa fa-calendar"></i> to show</small>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </fieldset>
                      <fieldset class="form-group border p-3">
                        <legend class="w-auto px-2">Endorsement for Annual / Intermediate:</legend>
                        <b-row>
                          <b-col md="6">
                            <b-form-group label-for="expired" label="Next Endorsement After ?">
                              <b-input-group size="md" append="Month">
                                <b-form-input type="number"></b-form-input>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label-for="notification" label="Notification Endorsement Before ?">
                              <b-input-group size="md" append="Month">
                                <b-form-input type="number"></b-form-input>
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label-for="1st_verification" label="1st Verification">
                              <b-form-input type="date" value="2019-12-19"></b-form-input>
                              <small style="float: right">click <i class="fa fa-calendar"></i> to show</small>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label-for="2nd_verification" label="2nd Verification">
                              <b-form-input type="date" value="2019-12-19" disabled></b-form-input>
                              <small style="float: right">click <i class="fa fa-calendar"></i> to show</small>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label-for="3rd_verification" label="3rd Verification">
                              <b-form-input type="date" value="2019-12-19" disabled></b-form-input>
                              <small style="float: right">click <i class="fa fa-calendar"></i> to show</small>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label-for="4th_verification" label="4th Verification">
                              <b-form-input type="date" value="2019-12-19" disabled></b-form-input>
                              <small style="float: right">click <i class="fa fa-calendar"></i> to show</small>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label-for="5th_verification" label="5th Verification">
                              <b-form-input type="date" value="2019-12-19" disabled></b-form-input>
                              <small style="float: right">click <i class="fa fa-calendar"></i> to show</small>
                            </b-form-group>
                          </b-col>
                          <b-col md="6">
                            <b-form-group label-for="6th_verification" label="6th Verification">
                              <b-form-input type="date" value="2019-12-19" disabled></b-form-input>
                              <small style="float: right">click <i class="fa fa-calendar"></i> to show</small>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </fieldset>
                      <fieldset class="form-group border p-3">
                        <legend class="w-auto px-2">Remarks:</legend>
                        <b-row>
                          <b-col md="3">
                            <label>Office Checked</label>
                          </b-col>
                          <b-col md="9">
                            <b-form-checkbox v-model="officeChecked" name="check-button" switch inline></b-form-checkbox>
                            <b-form-textarea id="description" rows="3" placeholder="Type Description" :disabled="officeChecked === false"></b-form-textarea>
                          </b-col>
                          <b-col md="3">
                            <label>Ship Checked</label>
                          </b-col>
                          <b-col md="9">
                            <b-form-checkbox v-model="shipChecked" name="check-button" switch inline></b-form-checkbox>
                            <b-form-textarea id="description" rows="3" placeholder="Type Description" :disabled="shipChecked === false"></b-form-textarea>
                          </b-col>
                        </b-row>
                      </fieldset>
                      <fieldset class="form-group border p-3">
                        <legend class="w-auto px-2">Notification Receiver:</legend>
                        <b-row>
                          <b-col md="2"></b-col>
                          <b-col md="8">
                            <b-form-input id="search" type="text" placeholder="Search..."></b-form-input>
                          </b-col>
                          <b-col md="2"></b-col>
                          <b-col md="12">
                            <hr>
                            <small class="text-muted">click images for checked / unchecked</small>
                            <b-row class="mt-4 mb-4">
                              <b-col md="3" class="text-center">
                                <div class="custom-control custom-checkbox image-checkbox">
                                  <input id="ck1b" type="checkbox" class="custom-control-input">
                                  <label class="custom-control-label" for="ck1b">
                                    <img :src="require('@assets/images/users/avatar-1.jpg')" alt="#" class="img-fluid">
                                  </label>
                                  <small><strong>John Doe</strong></small>
                                </div>
                              </b-col>
                              <b-col md="3" class="text-center">
                                <div class="custom-control custom-checkbox image-checkbox">
                                  <input id="ck2b" type="checkbox" class="custom-control-input">
                                  <label class="custom-control-label" for="ck2b">
                                    <img :src="require('@assets/images/users/avatar-1.jpg')" alt="#" class="img-fluid">
                                  </label>
                                  <small><strong>Nathan</strong></small>
                                </div>
                              </b-col>
                              <b-col md="3" class="text-center">
                                <div class="custom-control custom-checkbox image-checkbox">
                                  <input id="ck3b" type="checkbox" class="custom-control-input">
                                  <label class="custom-control-label" for="ck3b">
                                    <img :src="require('@assets/images/users/avatar-1.jpg')" alt="#" class="img-fluid">
                                  </label>
                                  <small><strong>Mike</strong></small>
                                </div>
                              </b-col>
                              <b-col md="3" class="text-center">
                                <div class="custom-control custom-checkbox image-checkbox">
                                  <input id="ck4b" type="checkbox" class="custom-control-input">
                                  <label class="custom-control-label" for="ck4b">
                                    <img :src="require('@assets/images/users/avatar-1.jpg')" alt="#" class="img-fluid">
                                  </label>
                                  <small><strong>Gerald</strong></small>
                                </div>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </fieldset>
                    </b-modal>
                  </b-col>
                </b-row>
              </b-card-title>
              <b-card-body>
                <b-row>
                  <b-col cols="12" md="3">
                    <b-form-group label="Search Certifiicate:" label-for="kind-fleet">
                      <b-form-input id="fleet_name" type="text" placeholder="Search..."></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="2">
                    <b-form-group label="Status Certificate:" label-for="statusCertificate">
                      <b-form-select v-model="selectedStatusCertificate" plain :options="statusCertificate" size="lg">
                        <template v-slot:first>
                          <b-form-select-option disabled value="">Select Status</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="2">
                    <b-form-group label="Type Certificate:" label-for="typeCertificate">
                      <b-form-select v-model="selectedTypeCertificate" plain :options="typeCertificate" size="lg">
                        <template v-slot:first>
                          <b-form-select-option disabled value="">Select Type</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="2">
                    <b-form-group label="Filter" label-for="button_search">
                      <b-button variant="primary" class="mb-3 mr-1"><i class="fa fa-filter"></i></b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="12">
            <gantt-elastic :tasks="tasks" :options="options">
              <gantt-elastic-header slot="header" :options="options"></gantt-elastic-header>
            </gantt-elastic>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Master Certificate">
        <b-row>
          <b-col lg="12">
            <b-card class="iq-mb-3">
              <b-card-title>
                <h5 class="card-title font-size-16">Master Certificate</h5>
              </b-card-title>
              <b-card-text>
                <!-- Top Section !-->
                <b-row>
                  <b-col lg="12">
                    <b-row>
                      <b-col cols="6">
                        <b-form-input id="fleet_name" type="text" placeholder="Type Master Certificate"></b-form-input>
                      </b-col>
                      <b-col cols="3">
                        <b-button block variant="primary" class="mt-1"><i class="fa fa-search"></i>Search Master</b-button>
                      </b-col>
                      <b-col cols="3">
                        <b-button block variant="info" class="mt-1"><i class="fa fa-file-excel"></i>Export Excel</b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <!-- End Top Section !-->
                <!-- Content Section !-->
                <b-row class="mt-3">
                  <b-col sm="4">
                    <b-col lg="12">
                      <b-card class="iq-mb-3">
                        <b-card-title>
                          <h5 class="card-title font-size-16">Add Master Certificate</h5>
                        </b-card-title>
                        <b-card-text>
                          <b-toast variant="success" visible static no-auto-hide no-close-button toast-class="bg-success" body-class="text-white"  header-class="bg-success text-white">
                            <template v-slot:toast-title>
                              <strong class="mr-auto text-white"><i class="fa fa-bullhorn"></i> Notification</strong>
                              <small class="text-white">11 mins ago</small>
                              <button type="button" class="ml-2 mb-1 close text-white" data-dismiss="toast" aria-label="Close">
                                <span aria-hidden="true">×</span>
                              </button>
                            </template>
                            You've Succed Create Master Certificate
                          </b-toast>

                          <b-toast variant="danger" visible static no-auto-hide no-close-button toast-class="bg-danger" body-class="text-white"  header-class="bg-danger text-white">
                            <template v-slot:toast-title>
                              <strong class="mr-auto text-white"><i class="fa fa-bullhorn"></i> Notification</strong>
                              <small class="text-white">11 mins ago</small>
                              <button type="button" class="ml-2 mb-1 close text-white" data-dismiss="toast" aria-label="Close">
                                <span aria-hidden="true">×</span>
                              </button>
                            </template>
                            You've Failed Create Master Certificate
                          </b-toast>

                          <b-form>
                            <b-form-group label="Category" label-for="Category">
                              <b-row>
                                <b-col md="8">
                                  <v-select label="text" :options="category"></v-select>
                                </b-col>
                                <b-col md="4">
                                  <a v-if="!showAddCategory" href="" @click.prevent="showAddCategoryAction">Add Category</a>
                                  <a v-else href="" @click.prevent="hideAddCategory">Cancel</a>
                                </b-col>
                              </b-row>
                              <b-row v-if="showAddCategory" class="mt-3">
                                <b-col md="12">
                                  <div class="iq-search-bar">
                                    <form action="#" class="searchbox" style="width: 95% !important;">
                                      <input type="text" class="text search-input" placeholder="Type Category">
                                      <a class="search-link" href="#"><i class="fa fa-plus"></i></a>
                                    </form>
                                  </div>
                                </b-col>
                              </b-row>
                            </b-form-group>
                            <b-form-group label="Name Certificate" label-for="name_certificate">
                              <b-form-input id="name_certificate" type="text" placeholder="Type Name Certificate"></b-form-input>
                            </b-form-group>
                            <!--  <b-form-group label="Mempunyai Sub Name of Certificate?" label-for="hasSub">
                              <b-form-checkbox v-model="hasSub" name="check-button" switch inline>
                                Yes / No
                              </b-form-checkbox>
                            </b-form-group>-->
                            <b-form-group v-if="hasSub" label="Name Certificate" label-for="name_certificate_sub">
                              <b-form-input id="name_certificate_sub" type="text" placeholder="Type Name"></b-form-input>
                            </b-form-group>
                            <b-form-group label="Type" label-for="type">
                              <ul>
                                <template v-for="(item,index) in remarks">
                                  <li :key="index">
                                    <b-form-radio :key="index" class="custom-radio-color-checked" inline :color="item.color" name="color" :value="item.value" :disabled="item.disabled">{{ item.label }}</b-form-radio>
                                  </li>
                                </template>
                              </ul>
                            </b-form-group>
                            <b-form-group label="Setting Reminder" label-for="reminder">
                              <b-row>
                                <b-col md="6">
                                  <template v-for="(item,index) in reminder" >
                                    <div :key="index" style="margin-top: 5px">
                                      <b-form-checkbox :key="index" v-model="item.checked" :disabled="item.disabled" name="check-button" switch inline>
                                      {{ item.label }}
                                      </b-form-checkbox>
                                    </div>
                                  </template>
                                </b-col>
                              </b-row>
                            </b-form-group>
                            <b-form-group label="Description" label-for="description">
                              <b-form-textarea id="description" rows="3" placeholder="Type Description"></b-form-textarea>
                            </b-form-group>
                          </b-form>
                          <b-row>
                            <b-col md="12" class="text-right">
                              <b-button type="submit" variant="none" class="iq-bg-danger"><i class="fa fa-close"></i> Cancel</b-button>
                              <b-button type="submit" class="ml-3" variant="primary"><i class="fa fa-save"></i> Submit</b-button>
                            </b-col>
                          </b-row>
                        </b-card-text>
                      </b-card>
                    </b-col>
                  </b-col>
                  <b-col sm="8">
                    <b-card class="iq-mb-3">
                      <b-card-title>
                        <h5 class="card-title font-size-16">List Master Certificate</h5>
                      </b-card-title>
                      <b-card-text>
                        <table class="table table-striped">
                          <thead>
                          <tr>
                            <th width="10%" class="text-center">NO</th>
                            <th width="25%" class="text-center">Name Certificate</th>
                            <th width="35%" class="text-center">Description</th>
                            <th width="15%" class="text-center">Remark</th>
                            <th width="15%" class="text-center">Action</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td class="text-center">1</td>
                            <td>SNPP/IOPP/Marpol</td>
                            <td>As a leading classification society, Bureau Veritas is dedicated to the creation and support of international shipping standards. </td>
                            <td>Permanen</td>
                            <td class="text-center">
                              <b-button variant="success" size="sm" class="mt-2"><i class="fa fa-edit" ></i></b-button>
                              <b-button variant="danger" size="sm" class="mt-2"><i class="fa fa-trash"></i></b-button>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-center">2</td>
                            <td>Sertifikat Safe Manning</td>
                            <td>Our expertise in tug design assessment has led us to develop improved stability requirements for towing and escorting vessels</td>
                            <td>Permanen</td>
                            <td class="text-center">
                              <b-button variant="success" size="sm" class="mt-2"><i class="fa fa-edit" ></i></b-button>
                              <b-button variant="danger" size="sm" class="mt-2"><i class="fa fa-trash"></i></b-button>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-center">3</td>
                            <td>SNPP/IOPP/Marpol</td>
                            <td>These Rules have since been adopted by IMO as the international gold standard for the tug sector.</td>
                            <td>Tidak Permanen</td>
                            <td class="text-center">
                              <b-button variant="success" size="sm" class="mt-2"><i class="fa fa-edit" ></i></b-button>
                              <b-button variant="danger" size="sm" class="mt-2"><i class="fa fa-trash"></i></b-button>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-center">4</td>
                            <td>BKI Class - Lambung</td>
                            <td>LNG propulsion), as reducing emissions and fuel consumption have become major decision-making factors.</td>
                            <td>Permanen Endorsement</td>
                            <td class="text-center">
                              <b-button variant="success" size="sm" class="mt-2"><i class="fa fa-edit" ></i></b-button>
                              <b-button variant="danger" size="sm" class="mt-2"><i class="fa fa-trash"></i></b-button>
                            </td>
                          </tr>
                          <tr>
                            <td class="text-center">5</td>
                            <td>BKI Class - Intermediate Survey</td>
                            <td>However, tugboat safety issues must be addressed before vessels change their fuel systems.</td>
                            <td>Permanen</td>
                            <td class="text-center">
                              <b-button variant="success" size="sm" class="mt-2"><i class="fa fa-edit" ></i></b-button>
                              <b-button variant="danger" size="sm" class="mt-2"><i class="fa fa-trash"></i></b-button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </b-card-text>
                    </b-card>
                  </b-col>
                </b-row>
                <!-- End Content Section !-->
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>
